import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PortfolioStorage } from '../enums/portfolio-storage.enum';
import { StorageService } from '../services/storage.service';

const uris = {
  noNeedsAuthToken: ['assets', 'storage.googleapis'] as string[],
  needsPortalAuthToken: ['api.inteligenciadevida'] as string[]
} as const;

export function requestNeedsPortalAuthToken(url: string): boolean {
  return requestNeedsUri(uris.needsPortalAuthToken, url);
}

export function requestNoNeedsAuthToken(url: string): boolean {
  return requestNeedsUri(uris.noNeedsAuthToken, url);
}

/** `GET .../auth/user` usa JWT (access), não o token do portal. */
export function requestAuthUserEndpoint(url: string): boolean {
  const path = url.split('?')[0].split('#')[0];
  return /\/auth\/user$/i.test(path) || /\/auth\/user\//i.test(path);
}

function requestNeedsUri(uri: string[], url: string): boolean {
  return new RegExp(`${uri.join('|')}`, 'i').test(url);
}
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private storageService: StorageService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (requestNoNeedsAuthToken(request.url)) {
      return next.handle(request);
    }

    let accessToken = this.storageService.get<string>(
      PortfolioStorage.AccessToken
    );

    if (
      requestNeedsPortalAuthToken(request.url) &&
      !requestAuthUserEndpoint(request.url)
    ) {
      accessToken = this.storageService.get<string>(
        PortfolioStorage.PortalToken
      );
    }

    return next.handle(
      request.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      })
    );
  }
}
